import { render, staticRenderFns } from "./ProgressJob.vue?vue&type=template&id=b63e4dd0&lang=html&"
import script from "./ProgressJob.vue?vue&type=script&lang=js&"
export * from "./ProgressJob.vue?vue&type=script&lang=js&"
import style0 from "./ProgressJob.vue?vue&type=style&index=0&id=b63e4dd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports